export const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "vi", label: "Tiếng Việt" },
  { value: "de", label: "Deutsch" },
  { value: "ar", label: "عرب" },
  { value: "th", label: "ไทย" },
  { value: "ko", label: "한국인" },
  { value: "ja", label: "日本" },
  { value: "it", label: "Italiano" },
  { value: "hi", label: "हिंदी" },
  { value: "ms", label: "Bahasa Melayu" },
  { value: "id", label: "Bahasa Indonesia" },
  { value: "es", label: "Español" },
  { value: "fr", label: "Français" },
  { value: "pt", label: "Português" },
  { value: "nl", label: "Nederlands" },
  { value: "sv", label: "Svenska" },
  { value: "pl", label: "Polski" },
  { value: "uk", label: "Українська" },
  { value: "ru", label: "Русский" },
  { value: "zh", label: "中文" },
  { value: "he", label: "עברית" },
  { value: "tl", label: "Tagalog" },
  { value: "cs", label: "Čeština" },
  { value: "no", label: "Norsk" },
  { value: "tr", label: "Türkçe" },
  { value: "da", label: "Dansk" },
  { value: "jw", label: "Javanese" },
  { value: "ur", label: "اردو" },
  { value: "bn", label: "বাংলা" },
  { value: "ta", label: "தமிழ்" },
  { value: "te", label: "తెలుగు" },
  { value: "mr", label: "मराठी" },
] as const;

export const DEFAULT_LANGUAGE = "en";

export const FNS_LOCALE_NAME: Record<string, string> = {
  en: "en-US",
  vi: "vi",
  de: "de",
  ar: "ar",
  th: "th",
  ko: "ko",
  ja: "ja",
  it: "it",
  hi: "hi",
  ms: "ms",
  id: "id",
  es: "es",
  fr: "fr",
  pt: "pt",
  nl: "nl",
  sv: "sv",
  pl: "pl",
  uk: "uk",
  ru: "ru",
  zh: "zh-CN",
  he: "he",
  tl: "tl",
  cs: "cs",
  no: "nb",
  tr: "tr",
  da: "da",
  jw: "jv",
  ur: "ur",
  bn: "bn",
  ta: "ta",
  te: "te",
  mr: "mr",
};
